module.exports = __webpack_public_path__ + "static/media/ticket-dashed-line-vertical.4e2de4de.svg";